import { render, staticRenderFns } from "./UploadComprovante.vue?vue&type=template&id=801ea118"
import script from "./UploadComprovante.vue?vue&type=script&lang=js"
export * from "./UploadComprovante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports